// extracted by mini-css-extract-plugin
module.exports = {"faqs":"styles_faqs__LuqUI"};